import { Card as MuiCard, useTheme } from '@mui/material';
import React from 'react';

type PropTypes = {
  cardHeader: React.JSX.Element;
  cardContainer: React.JSX.Element;
  cardContent: React.JSX.Element;
  overflow?: string;
};

export default function Card(props: PropTypes) {
  const { cardHeader, cardContainer, cardContent, overflow } = props;
  const theme: any = useTheme();

  return (
    <MuiCard
      sx={{
        overflow: overflow,
        background: (theme) => theme.palette.primary.light,
        borderRadius: '15px',
        padding: { xl: theme.spacing(3), xs: 1 },
        paddingTop: { sm: 1 },
      }}
    >
      {cardHeader}
      {cardContainer}
      {cardContent}
    </MuiCard>
  );
}
